// extracted by mini-css-extract-plugin
module.exports = {"brand":"Brand_brand__XsW_Y","container":"Brand_container__yyQWd","title":"Brand_title___Lz0k","strong":"Brand_strong__ZfqcI"};